module.exports = __webpack_public_path__ + "img/11.c58f3218.png";